<template>
  <div class="app">
    <!-- 底  -->
    <!-- <div class="youshi">我们的优势</div>
    <div style="margin-left: auto;margin-right: auto;">
      <div style="display:flex;justify-content: center;">
        <div class="box">
          <div class="goodtitle">资源&nbsp;更丰富
          </div>
          <div class="goodtext">地址、工商、税务</div>
          <div class="goodtext">优质解决方案</div>
        </div>
        <div class="box">
          <div class="goodtitle">服务&nbsp;更专业
          </div>
          <div class="goodtext">会计、人事、客服</div>
          <div class="goodtext">团队服务有保障</div>
        </div>
      </div>
      <div style="display:flex;justify-content: center;">
        <div class="box">
          <div class="goodtitle">经验&nbsp;更全面
          </div>
          <div class="goodtext">上千家企业案例</div>
          <div class="goodtext">解决问题轻车熟路</div>
        </div>
        <div class="box">
          <div class="goodtitle">老板&nbsp;更放心
          </div>
          <div class="goodtext">管理规范&nbsp;流程明晰</div>
          <div class="goodtext">认真做事&nbsp;诚信负责</div>
        </div>
      </div>
    </div> -->


    <div class="youshi">
      <div style="display:flex;justify-content:center;align-items:center;">
        <div>合作热线 <i class="el-icon-phone-outline"></i></div>
        <a href="tel:13910303798" style="text-decoration: none;">
          <div class="rexian">&nbsp;1391 0303 798</div>
        </a>
      </div>
    </div>
  </div>
</template>
  
<script>
export default {
  name: 'Youshi',
  data() {
    return {
    }
  },
  methods: {
    pathue() {
      this.$router.push('/wangEditor');
    },
    pathRemen() {
      this.$router.push('/remen')
    },
    pathIndex() {
      this.$router.push('/');
    },
    pathCompanyReg() {
      this.$router.push('/zhuce')
    },
    pathJizhang() {
      this.$router.push('/jizhang')
    },
    pathgongshang() {
      this.$router.push('/gongshang')
    },
    pathshuiwu() {
      this.$router.push('/shuiwu');
    },
    pathzhichan() {
      this.$router.push('/zhichan')
    },
    pathxuke() {
      this.$router.push('/xuke')
    },
    pathrenshi() {
      this.$router.push('/renshi')
    },
    pathxueyuan() {
      this.$router.push('/xueyuan');
    },
    pathabout() {
      this.$router.push('/about')
    },
    pathcontact() {
      this.$router.push('/contact')
    },
  }
}
</script>
  
<style>
.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}

.el-carousel__button {
  background-color: #000 !important;
}

.el-menu-item.is-active {
  background-color: #b30101 !important;
}

.el-menu--horizontal>.el-menu-item {
  float: left;
  height: 45px !important;
  line-height: 45px !important;
  margin: 0;
}

@media (max-width: 768px) {
  .responsive-carousel el-carousel el-carousel--horizontal {
    width: 100%;
  }

  .el-carousel__indicators el-carousel__indicators--horizontal {
    margin-top: 15px !important
  }

  .el-pager li {
    padding: 0 0px !important;
    min-width: 25.5px !important;
  }

  .el-menu--horizontal>.el-menu-item {
    height: 30px !important;
    line-height: 30px !important;
  }

}
</style>
  
  
<style scoped>
.box {
  width: 290px;
  height: 180px;
  background-color: #84c2ff;
  justify-content: center;
  align-items: center;
  margin-left: 2px;
  margin-top: 2px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
}

.goodtitle {
  font-size: 1.7rem;
  margin-bottom: 20px;
  color: rgb(255, 255, 255);
}

.goodtext {
  font-size: 1.5rem;
}


.youshi {
  margin-top: 34px;
  margin-left: auto;
  margin-right: auto;
  font-size: 35px;
}

.rexian {
  font-size: 44px;
  font-weight: 700;
  font-family: Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
  color: #f70104;
}


@media (max-width: 768px) {
  .box {
    width: 30vh;
    height: 15vh;
    background-color: #84c2ff;
    justify-content: center;
    align-items: center;
    margin-left: 2px;
    margin-top: 2px;
    border-radius: 4px;
  }

  .goodtitle {
    font-size: 1rem !important;
    margin-top: 10px !important;
    margin-bottom: 10px !important;
    color: rgb(255, 255, 255);
  }

  .goodtext {
    font-size: 0.8rem !important;
  }
  
  .youshi {
    margin-top: 2vh;
    margin-left: auto;
    margin-right: auto;
    font-size: 17px;
  }

  .rexian {
    font-size: 22px;
  }
}
</style>
  


// WEBPACK FOOTER //
// src/components/Youshi.vue